import * as Toastr from "toastr";
import { InitPage } from "../index";
import { ImportFile } from "../common/import_file";

declare var assignUrl: string;

class Locations {
  constructor() {
    InitPage("index", () => {
      new ImportFile();

      $(document).on("click", "#assign-btn", function () {
        const all = $("input:checkbox[name*=locations]")
          .map((_idx, elm) => $(elm).data("id"))
          .toArray();
        const checked = $("input:checkbox[name*=locations]:checked")
          .map((_idx, elm) => $(elm).data("id"))
          .toArray();

        $.ajax({
          type: "PUT",
          dataType: "json",
          url: assignUrl,
          data: { all, checked },
          success: function () {
            Toastr.success("Location(s) assigned/unassigned successfully");
          },
        });
      });
    });

    $(".support-tz").each(function () {
      $(this).attr(
        "href",
        $(this)
          .attr("href")
          .replace("tz", Intl.DateTimeFormat().resolvedOptions().timeZone),
      );
    });
  }
}

export function LoadPage() {
  InitPage("locations", () => {
    new Locations();
  });
}
